import { useSyncExternalStore } from 'react';

import {
  getStreamSourceVersion,
  resolveStreamUrl,
  subscribeStreamSource,
} from '../utils/streamSource';

/**
 * Returns `resolveStreamUrl` and re-renders the caller when a stream
 * reachability probe settles, so a tile can upgrade from proxy to direct.
 */
export function useStreamSource(): typeof resolveStreamUrl {
  useSyncExternalStore(subscribeStreamSource, getStreamSourceVersion, getStreamSourceVersion);
  return resolveStreamUrl;
}
